/* eslint-disable */
export default {
  recentActivities: 'Viimeisimmät tapahtumat',
  text: 'Tekstiviesti',
  fax: 'Faksi',
  voicemail: 'Puhelinvastaaja',
  call: 'Soita',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
